import { graphql } from '@apollo/client/react/hoc'

import { getCountry } from '../../helpers/get-country'
import { ApplicationError } from '../../helpers/errors'

import query from './query.graphql'

export { query }

export const mapPropsToOptions = ({ staticContext }) => ({
  variables: {
    country: getCountry(staticContext),
  },
  errorPolicy: 'ignore',
  context: { version: 2 },
})

export const mapDataToProps = ({ data }) => {
  const { loading, error, cfContentPageCollection } = data

  if (error) {
    return {
      error: new ApplicationError(error),
    }
  } else if (loading) {
    return { loading }
  }

  return {
    giftCards: cfContentPageCollection?.items?.[0],
  }
}

const withGiftCards = graphql(query, {
  options: mapPropsToOptions,
  props: mapDataToProps,
})

export default withGiftCards
